<div class="closing-x-wrap">
    <mat-icon class="close-icon condenced" alt="Close dialog" (click)="close()"> close </mat-icon>
</div>

<!-- show doc info or deal # -->
<div>
    <ng-container *ngIf="doc; else dealId">
        <h1 mat-dialog-title class="doc">{{ doc.displayName }}</h1>
        <h3 class="sub-header">
            Document ID: <span>{{ doc.documentId }}</span>
        </h3>
    </ng-container>
    <ng-template #dealId>
        <h1 mat-dialog-title class="deal">{{ data.uniqueTitle ? data.uniqueTitle + ':' : 'Deal Jacket ID:' }} {{ deal.dealId }}</h1>
    </ng-template>

    <div class="info">
        <h3>
            Customer:
            <br />
            <span>{{ auditTrail[0].buyerName }}</span>
        </h3>
        <h3>
            Generating Report for Deal ID:
            <br />
            <ng-container *ngIf="doc; else dealInfo">
                <span>{{ doc.dealId }}</span>
            </ng-container>
            <ng-template #dealInfo>
                <span>{{ deal.dealId }}</span>
            </ng-template>
        </h3>
        <h3>
            Report Run Date:
            <br />
            <span>{{ auditTrail[0].runDate }}</span>
        </h3>
    </div>

    <div mat-dialog-content>
        <div class="audit-trail" *ngIf="auditTrail">
            <div class="audit-item" *ngFor="let t of auditTrail">
                <p>
                    <!-- https://mui.com/material-ui/material-icons -->
                    <ng-container *ngIf="t.iconName === 'Document' && t.actionPerformed !== 'Viewed Document'">
                        <mat-icon>description</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="t.iconName === 'LinkOpen'"><mat-icon>mobile_friendly</mat-icon></ng-container>
                    <ng-container *ngIf="t.iconName === 'LinkSent'"><mat-icon>phone_forwarded</mat-icon></ng-container>
                    <ng-container *ngIf="t.iconName === 'Merge'"><mat-icon>merge</mat-icon></ng-container>
                    <ng-container *ngIf="t.iconName === 'Moved'">
                        <mat-icon>location_on</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="t.iconName === 'Print'">
                        <mat-icon>print</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="t.iconName === 'Signed'">
                        <mat-icon>edit_document</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="t.iconName === 'Sync'"><mat-icon>sync_all</mat-icon></ng-container>
                    <ng-container *ngIf="t.actionPerformed === 'Viewed Document'">
                        <mat-icon>plagiarism</mat-icon>
                    </ng-container>
                </p>
                <div class="info-wrap">
                    <p style="margin-bottom: 5px" class="action-performed">
                        <b>
                            {{ t.actionPerformed }}
                        </b>
                        <span *ngIf="deal && t.documentName"> &nbsp; {{ t.documentName }} </span>
                    </p>
                    <pre *ngIf="showDiff && deal && !t.documentName"><b>Previous:</b>{{t.previousValues}}</pre>
                    <pre *ngIf="showDiff && deal && !t.documentName"><b>Current:</b>{{t.currentValues}}</pre>
                    <p class="second-row">{{ formattedDate(t.activityDate) }} - {{ t.actionPerformedBy }}</p>
                </div>
            </div>
        </div>

        <p>
            Generated by - Digital Deal Jacket - {{ dealership.name }} ({{ this.dealership.dealerId | dealerIdTransform }} | {{ this.dealership.oemCode
            }}{{ this.dealership.oemDealerId }})
        </p>
    </div>
    <div class="print-wrap">
        <button (click)="printTest()" class="primary" mat-button>Print</button>
    </div>
</div>

<div id="print-content">
    <ng-container *ngIf="doc">
        <h1 id="header" mat-dialog-title class="doc">{{ doc.displayName }}</h1>
        <h3 id="sub-header" class="sub-header">
            Document ID: <span>{{ doc.documentId }}</span>
        </h3>
    </ng-container>
    <ng-container *ngIf="deal">
        <h1 id="deal-number" mat-dialog-title class="deal">Deal #: {{ deal.dealId }}</h1>
    </ng-container>

    <div id="info-wrap" class="info">
        <h4 id="customer">
            Customer:
            <span>{{ auditTrail[0].buyerName }}</span>
        </h4>
        <h4 id="generating-report">
            Generating Report for Deal ID:
            <ng-container *ngIf="doc">
                <span>{{ doc.dealId }}</span>
            </ng-container>
            <ng-container *ngIf="deal">
                <span>{{ deal.dealId }}</span>
            </ng-container>
        </h4>
        <h4 id="report-run-date">
            Report Run Date:
            <span>{{ auditTrail[0].runDate }}</span>
        </h4>
    </div>

    <!--Below dialog content is what appears in the printed audits some inline styles are needed-->

    <div mat-dialog-content>
        <div id="audit-wrap" style="-webkit-print-color-adjust: exact !important; print-color-adjust: exact !important" class="audit-trail" *ngIf="auditTrail">
            <div
                class="audit-item"
                [style]="
                    auditTrail.indexOf(t) % 2 === 0 ? 'background-color: #e2e2e2; padding: 0.2rem 1rem' : 'background-color: #ffffff; padding: 0.2rem 1rem;'
                "
                *ngFor="let t of auditTrail"
            >
                <div class="info-wrap">
                    <p style="margin-bottom: 5px" class="action-performed">
                        <b>
                            {{ t.actionPerformed }}
                        </b>
                        <span *ngIf="deal">&nbsp;- {{ t.documentName }}</span>
                    </p>
                    <pre *ngIf="deal && !t.documentName"> <b>Previous: </b> {{ t.previousValues }} </pre>
                    <pre *ngIf="deal && !t.documentName"> <b>Current: </b>   {{ t.currentValues }} </pre>
                    <p style="margin-top: 0" class="activity-date second-row">{{ t.activityDate }} {{ t.actionPerformedBy }}</p>
                </div>
            </div>
        </div>

        <p>
            Generated by - Digital Deal Jacket - {{ dealership.name }} ({{ this.dealership.dealerId | dealerIdTransform }} | {{ this.dealership.oemCode
            }}{{ this.dealership.oemDealerId }})
        </p>
    </div>
</div>
